module.exports = __webpack_public_path__ + "img/menu.5ece4fee.svg";